<template>
    <span>
        <b-button
            class="align-baseline mr-1"
            title="Change card icon"
            v-b-modal="changeIconModal"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'image']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline mr-1"
            title="Change card content"
            v-b-modal="changeCardContentModal"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'pencil-alt']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete Partner"
            v-b-modal="deleteModalId"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>        
        <modal
            :id="changeIconModal"
            :ok-disabled="fileUploadForbidden"
            title="Change partner card icon"
            ok-title="Upload"
            @shown="onModalShown"
            @ok="changeIcon"
            @hide="clearIconInput"
        >
            <b-container fluid>
                <b-row class="my-1">
                    <b-form-group label="Icon:" label-for="icon-default">
                        <b-form-file 
                            accept="image/*"
                            v-model="attachedLogo"
                            id="icon-default"
                        >
                        </b-form-file>
                    </b-form-group>
                </b-row>
            </b-container>
        </modal>
        <modal
            :id="changeCardContentModal"
            title="Change partner card content"
            ok-title="Proceed"
            size="lg"
            scrollable
            @shown="onModalShown"
            @ok="changeContent"
        >
            <b-container fluid>
                <b-row class="my-1">
                    <b-col sm="12">
                        <TextEditor 
                            ref="editor"
                            :options="editorModules"
                            v-model="params.data.modal_text"
                        />
                    </b-col>
                </b-row>
            </b-container>
        </modal>
        <modal
            :id="deleteModalId"
            title="Delete partner card"
            @shown="onModalShown"
            @ok="deletePartner"
        >Permanently delete {{partnerName}}?</modal>
    </span>
</template>

<script>
    import API from '../../../.././api';
    import Modal from '../../../generic/modal/modal.vue';
    const TextEditor = () => import(
        /* webpackChunkName: "lx-text-editor" */
        '../../../generic/editor/quill-editor.vue'
    );

    export default {
        components: {
            Modal, TextEditor
        },
        data() {
            return {
                partnerId: 0,
                attachedLogo: null,
                partnerName: 'this partner card',
                deleteModalId: '',
                editorModules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ direction: 'rtl' }],
                        [{ size: ['small', false, 'large', 'huge'] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ font: [] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        ['clean'],
                        ['link', 'image'],
                    ],
                },
            };
        },
        computed: {
            fileUploadForbidden() {
                if (this.attachedLogo == null || this.attachedLogo == undefined) {
                    return true;
                }
                return false;
            },
        },
        created() {
            this.partnerId = this.params.data.id;
            if (this.params.data.title) {
                this.partnerName = `"${this.params.data.title}"`;
            }
            this.deleteModalId = `modal-delete-partner-${this.partnerId}`;
            this.changeCardContentModal = `modal-change-content${this.partnerId}`;
            this.changeIconModal = `modal-change-icon${this.partnerId}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            async deletePartner() {
                try {
                    await API.delete(`/app/partner-cards/info/${this.partnerId}/`);
                    this.successToast({text: 'Partner card has been deleted permanently'})
                } catch (error) {
                    const response = error.response;
                    const detail =
                        response && response.data && response.data.detail
                            ? ' ' + response.data.detail
                            : '';
                    this.errorToast({text: `Could not delete partner card.${detail}`})
                    return;
                }
                this.params.api.applyTransaction({
                    remove: [this.params.node],
                });
            },
            async changeContent() {
                try {
                    await API.put(`/app/partner-cards/info/${this.partnerId}/`, {
                        modal_text: this.params.data.modal_text
                    });
                    this.successToast({text: 'Partner card data has been changed'})
                } catch (error) {
                    const response = error.response;
                    const detail =
                        response && response.data && response.data.detail
                            ? ' ' + response.data.detail
                            : '';
                    this.errorToast({ text: `Could not change partner card data.${detail}`})
                    return;
                }
            },
            async changeIcon() {
                let formData = new FormData();
                formData.append('logo', this.attachedLogo);
                try {
                    await API.put(`/app/partner-cards/info/${this.partnerId}/`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    await this.params.update()
                    this.successToast({text: 'Partner card logo has been updated'})
                } catch (error) {
                    const response = error.response;
                    const detail =
                        response && response.data && response.data.detail
                            ? ' ' + response.data.detail
                            : '';
                    this.errorToast({text: `Could not upload partner logo.${detail}`})
                    return;
                }
                this.clearIconInput();
            },

            clearIconInput() {
                this.attachedLogo = null;
            }
        },
    };
</script>

<style lang="scss" scoped>    
    .vue-app-wrapper .form-group {
        width: 100%;
    }
</style>